/* @sravni/react-design-system version 0.2.59 */
import Skeleton$1 from './src/Skeleton.js';
import Avatar from './src/Avatar.js';
import Button from './src/Button.js';
import Paragraph from './src/Paragraph.js';

var Skeleton = Skeleton$1;
Skeleton.Avatar = Avatar;
Skeleton.Button = Button;
Skeleton.Paragraph = Paragraph;

export { Skeleton };
//# sourceMappingURL=index.js.map
